import { UseHandleAction } from '../../../../lib/hooks/useHandleAction';
import { Api } from '../../../../lib/types/apiSpec';

export enum TeamAccordionItemAction {
  ADD_MEMBER = 'addMember',
  CREATE_SUBTEAM = 'createSubteam',
  DELETE_TEAM = 'deleteTeam',
  RENAME_TEAM = 'renameTeam',
}
export type TeamAccordionItemProps = {
  overdue?: number;
  membersCount: number;
  isExpanded: boolean;
  className?: string;
  teamMeta: Api.TeamSummary;
};

export type TeamAccordionItemActionsProps = { onUserModification: () => void; teamMeta: Api.TeamSummary };

export type CreateSubteamAndRenameActionProps = {
  action: UseHandleAction;
  successMessage: string;
};

export type CommonTeamDialogType = TeamAccordionItemAction.CREATE_SUBTEAM | TeamAccordionItemAction.RENAME_TEAM;

export type SubteamDialogProps = {
  onClose: () => void;
  teamMeta: Api.TeamSummary;
};
